'use client';
import e__default from 'react';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { SwanComboboxContextProvider } from './combobox.context.js';
import { FlexBox } from '../flex-box/flex-box.component.js';
import { CollectionContextProvider } from '../../contexts/internal/collection/collection.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { processStyleProps } from '../../../core/utilities/swan-style.js';

const comboboxPropTypes = {};
const Combobox = renderWithRef('Combobox', comboboxPropTypes, (t, s)=>{
    useComponentStylesLoaded('Combobox', [
        SWAN_STYLE_KEY_MAP.listbox,
        SWAN_STYLE_KEY_MAP.popover
    ]);
    let { children: i, className: p, items: b, menuTrigger: x } = t, f = new Set([
        'swan-combobox-container'
    ]);
    return p && f.add(p), 'focus' === x && f.add('swan-combobox-container-with-focus-trigger'), e__default.createElement(FlexBox, {
        className: Array.from(processStyleProps(t, f)).join(' '),
        ref: s
    }, e__default.createElement(CollectionContextProvider, {
        items: b
    }, e__default.createElement(SwanComboboxContextProvider, t, i)));
});

export { Combobox, comboboxPropTypes };
